export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/c445464e9d5ab5582aee5503e8030d41.png"
                alt="IchiBan Marketing Digital"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
              Agência que atua no mercado de marketing digital para todos os tipos de negócios, utilizando Inteligência Artificial como suporte para operações e campanhas digitais, com foco em Growth Marketing como estratégia de crescimento dos resultados das empresas.
            </p>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-red-500"></i>
                <span className="text-gray-300">São José dos Campos, SP</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-phone-line text-red-500"></i>
                <button
                  onClick={() => window.open('https://wa.me/5512981309575', '_blank')}
                  className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  (12) 98130-9575
                </button>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-red-500"></i>
                <a
                  href="mailto:atendimento@ichiban1.com.br"
                  className="text-gray-300 hover:text-white transition-colors duration-300"
                >
                  atendimento@ichiban1.com.br
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Início
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Sobre Nós
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('founders')}
                  className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Fundadores
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Serviços
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('partnerships')}
                  className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Amizades
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  Contato
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Serviços</h3>
            <ul className="space-y-3">
              <li className="text-gray-300">Growth Marketing</li>
              <li className="text-gray-300">Inteligência Artificial</li>
              <li className="text-gray-300">SEO & SEM</li>
              <li className="text-gray-300">Analytics & BI</li>
              <li className="text-gray-300">Marketing de Conteúdo</li>
              <li className="text-gray-300">Social Media</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 mb-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            <div>
              <h4 className="text-lg font-semibold mb-4">Siga-nos nas Redes Sociais</h4>
              <div className="flex space-x-4">
                <a
                  href="https://www.instagram.com/ichibandigitalmarketing"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-red-600 transition-colors duration-300 w-12 h-12 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a
                  href="https://www.facebook.com/share/1C3EybVHVt/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-red-600 transition-colors duration-300 w-12 h-12 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a
                  href="https://www.linkedin.com/company/ichiban-marketing-digital/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-800 p-3 rounded-full hover:bg-red-600 transition-colors duration-300 w-12 h-12 flex items-center justify-center cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div className="text-center md:text-right">
              <h4 className="text-lg font-semibold mb-4">Newsletter</h4>
              <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2">
                <input
                  type="email"
                  placeholder="Seu e-mail"
                  className="px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-white"
                />
                <button className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors duration-300 whitespace-nowrap cursor-pointer">
                  Inscrever
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2025 IchiBan Marketing Digital. Todos os direitos reservados.
            </div>
            <div className="flex items-center space-x-1 text-gray-400 text-sm">
              <span>Feito com</span>
              <i className="ri-heart-fill text-red-500"></i>
              <span>pela equipe IchiBan</span>
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
